import {
  api_change_password_url,
  api_forgot_password_request_url,
  api_get_company_details_by_domain_url,
  api_get_company_process_stage_url,
  api_get_company_process_url,
  api_get_company_users_list,
  api_get_user_company_url,
  api_register_url,
  api_reset_password_url
} from "./userApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  parser_change_password,
  parser_company_details_by_domain,
  parser_forgot_password_request,
  parser_get_company_process,
  parser_get_company_process_stage,
  parser_get_user_company,
  parser_register,
  parser_reset_password
} from "./userParser";
import { isAuth, getLocalStorage, setLocalStorage } from "../../helpers/cookies";

export const forgot_password_request = createAsyncThunk(
  "forgot_password_request",
  async (payload) => {
    try {
      const response = await api_forgot_password_request_url(payload);
      const data = parser_forgot_password_request(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const signup = createAsyncThunk(
  "signup",
  async (payload) => {
    try {
      const response = await api_register_url(payload);
      const data = parser_register(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const reset_password = createAsyncThunk(
  "reset_pasword",
  async (payload) => {
    try {
      const { request_body, token } = payload;
      const response = await api_reset_password_url(request_body, token);
      const data = parser_reset_password(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const change_password = createAsyncThunk(
  "change_password",
  async (payload) => {
    try {
      const response = await api_change_password_url(payload);
      const data = parser_change_password(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_company_process = createAsyncThunk(
  "get_company_process",
  async (payload) => {
    try {
      const response = await api_get_company_process_url(payload);
      const data = parser_get_company_process(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_company_process_stage = createAsyncThunk(
  "get_company_process_stage",
  async (payload) => {
    try {
      const { company_id, process_id } = payload;
      const response = await api_get_company_process_stage_url(company_id, process_id);
      const data = parser_get_company_process_stage(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_user_company = createAsyncThunk(
  "get_user_company",
  async () => {
    try {
      const response = await api_get_user_company_url();
      const data = parser_get_user_company(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_company_details_by_domain = createAsyncThunk(
  "get_company_details_by_domain",
  async (payload) => {
    try {
      const response = await api_get_company_details_by_domain_url(payload);
      const data = parser_company_details_by_domain(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_company_users_list = createAsyncThunk(
  "get_company_users_list",
  async (company_id, { rejectWithValue }) => {
    try {
      const response = await api_get_company_users_list(company_id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  forgot_password_is_loading: false,
  show_password: {
    password: false,
    confirm_password: false
  },
  common_loading: false,
  signup_is_loading: false,
  company_process: [],
  company_process_stage: [],
  selected_process_tab: (getLocalStorage("selected_process_tab") && !isNaN(Number(getLocalStorage("selected_process_tab")))) ? Number(getLocalStorage("selected_process_tab")) : null,
  selected_stage_tab: (getLocalStorage("selected_stage_tab") && !isNaN(Number(getLocalStorage("selected_stage_tab")))) ? Number(getLocalStorage("selected_stage_tab")) : null,
  selected_company: (getLocalStorage("selected_company") && !isNaN(Number(getLocalStorage("selected_company")))) ? Number(getLocalStorage("selected_company")) : (isAuth() ? isAuth().company_id : null),
  user_company: [],
  show_change_password: {
    old_password: false,
    password: false,
    confirm_password: false
  },
  is_open: false,
  company_details: null,
  is_mobile_search_open: false,
  is_job_form: false,
  job_form: null,
  all_jobs_count: null,
  company_users_list: [],
  company_users_loading: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setShowPassword: (state, action) => {
      state.show_password = { ...state.show_password, ...action.payload };
    },
    setShowChangePassword: (state, action) => {
      state.show_change_password = { ...state.show_change_password, ...action.payload };
    },
    setProcessTab: (state, action) => {
      const val = action.payload !== null && action.payload !== undefined && action.payload !== "" && action.payload !== "null" ? Number(action.payload) : null;
      state.selected_process_tab = val;
      setLocalStorage("selected_process_tab", val);
      // Reset stage when process changes
      state.selected_stage_tab = 1;
      setLocalStorage("selected_stage_tab", 1);
      if (val && state.company_process && state.company_process.length > 0) {
        let process_obj = state.company_process.find(process => Number(process.id) === val || Number(process.process_id) === val);
        if (process_obj) {
          state.is_job_form = Object.keys(process_obj?.job_form || {}).length > 0;
          state.job_form = process_obj?.job_form || {};
        }
      }
    },
    setStageTab: (state, action) => {
      const val = action.payload !== null && action.payload !== undefined && action.payload !== "" && action.payload !== "null" ? Number(action.payload) : null;
      state.selected_stage_tab = val;
      setLocalStorage("selected_stage_tab", val);
    },
    setCompany: (state, action) => {
      state.selected_company = action.payload ? action.payload : '';
      setLocalStorage("selected_company", state.selected_company);
    },
    setResetState: (state, action) => {
      state.show_password = {
        password: false,
        confirm_password: false
      };
      state.forgot_password_is_loading = false;
      state.signup_is_loading = false;
    },
    setChangePasswordOpen: (state, action) => {
      state.is_open = action.payload;
    },
    setMobileSearchOpen: (state, action) => {
      state.is_mobile_search_open = action.payload;
    },
    setProcessHasJobForm: (state, action) => {
      if (!state.company_process || state.company_process.length === 0) return;
      let process_obj = state.company_process.find(process => Number(process.id) === Number(action.payload) || Number(process.process_id) === Number(action.payload));
      let is_job_form = process_obj ? Object.keys(process_obj?.job_form || {}).length > 0 : false;
      state.is_job_form = is_job_form;
      state.job_form = process_obj?.job_form || {};
    },
    setCommonLoading: (state, action) => {
      state.common_loading = action.payload;
    },
    setSelectedProcessTab: (state, action) => {
      const val = action.payload !== null && action.payload !== undefined && action.payload !== "" && action.payload !== "null" ? Number(action.payload) : null;
      state.selected_process_tab = val;
      setLocalStorage("selected_process_tab", val);
      state.selected_stage_tab = 1;
      setLocalStorage("selected_stage_tab", 1);
    },
    setSelectedStageTab: (state, action) => {
      const val = action.payload !== null && action.payload !== undefined && action.payload !== "" && action.payload !== "null" ? Number(action.payload) : null;
      state.selected_stage_tab = val;
      setLocalStorage("selected_stage_tab", val);
    }
  },
  extraReducers: (builder) => {
    // forgot password
    builder.addCase(forgot_password_request.pending, (state) => {
      state.forgot_password_is_loading = true;
    })
    builder.addCase(forgot_password_request.fulfilled, (state, action) => {
      state.forgot_password_is_loading = false;
    })
    builder.addCase(forgot_password_request.rejected, (state) => {
      state.forgot_password_is_loading = false;
    })
    // reset password
    builder.addCase(reset_password.pending, (state) => {
      state.forgot_password_is_loading = true;
    })
    builder.addCase(reset_password.fulfilled, (state, action) => {
      state.forgot_password_is_loading = false;
    })
    builder.addCase(reset_password.rejected, (state) => {
      state.forgot_password_is_loading = false;
    })
    // change password
    builder.addCase(change_password.pending, (state) => {
      state.forgot_password_is_loading = true;
    })
    builder.addCase(change_password.fulfilled, (state, action) => {
      state.forgot_password_is_loading = false;
    })
    builder.addCase(change_password.rejected, (state) => {
      state.forgot_password_is_loading = false;
    })
    // get company process
    builder.addCase(get_company_process.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_company_process.fulfilled, (state, action) => {
      state.common_loading = false;
      state.company_process = action.payload.data?.sort((a, b) => {
        const orderA = a.display_order !== null && a.display_order !== undefined ? parseInt(a.display_order) : 9999;
        const orderB = b.display_order !== null && b.display_order !== undefined ? parseInt(b.display_order) : 9999;
        return orderA - orderB;
      });

      if (state.selected_process_tab) {
        let process_obj = state.company_process?.find(process => process.id === state.selected_process_tab);
        let is_job_form = process_obj ? Object.keys(process_obj?.job_form || {}).length > 0 : false;
        state.is_job_form = is_job_form;
        state.job_form = process_obj?.job_form || {};
      }
    })
    builder.addCase(get_company_process.rejected, (state) => {
      state.common_loading = false;
    })
    // get company process stage
    builder.addCase(get_company_process_stage.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_company_process_stage.fulfilled, (state, action) => {
      state.common_loading = false;
      if (!state.selected_process_tab) {
        const { arg } = action.meta;
        state.selected_process_tab = arg.process_id;
      }
      const { data } = action.payload;
      if (state.selected_stage_tab === null) {
        state.selected_stage_tab = data.length > 0 ? data[0].id : 1;
      }
      state.company_process_stage = data.stages;
      state.all_jobs_count = data.total_jobs
    })
    builder.addCase(get_company_process_stage.rejected, (state) => {
      state.common_loading = false;
    })
    // get user company
    builder.addCase(get_user_company.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_user_company.fulfilled, (state, action) => {
      state.common_loading = false;
      const { company_user } = action.payload.data;
      state.user_company = company_user;
    })
    builder.addCase(get_user_company.rejected, (state) => {
      state.common_loading = false;
    })
    //register user
    builder.addCase(signup.pending, (state) => {
      state.signup_is_loading = true;
    })
    builder.addCase(signup.fulfilled, (state, action) => {
      state.signup_is_loading = false;
    })
    builder.addCase(signup.rejected, (state) => {
      state.signup_is_loading = false;
    })
    //get company details by domain
    builder.addCase(get_company_details_by_domain.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_company_details_by_domain.fulfilled, (state, action) => {
      state.common_loading = false;
      state.company_details = action.payload.data;
    })
    builder.addCase(get_company_details_by_domain.rejected, (state) => {
      state.common_loading = false;
    })
    // get company users list (for assignment dropdown)
    builder.addCase(get_company_users_list.pending, (state) => {
      state.company_users_loading = true;
    })
    builder.addCase(get_company_users_list.fulfilled, (state, action) => {
      state.company_users_loading = false;
      state.company_users_list = action.payload?.users || action.payload || [];
    })
    builder.addCase(get_company_users_list.rejected, (state) => {
      state.company_users_loading = false;
    })
  },
});

// Action creators are generated for each case reducer function
export const {
  setShowPassword,
  setProcessTab,
  setStageTab,
  setCompany,
  setResetState,
  setShowChangePassword,
  setChangePasswordOpen,
  setMobileSearchOpen,
  setProcessHasJobForm,
  setCommonLoading,
  setSelectedProcessTab,
  setSelectedStageTab
} = userSlice.actions;
export default userSlice.reducer;